/** @format */
import React from "react";
import { FormikProps } from "formik";
import CountDownTimer from "../CountDownTimer";
import { SendVerificationCode } from "../../../features/login/models";
import { StyledTextField, VerificationGrid } from "./Verification.Style";
import { VerificationButton } from "../../../features/applicant/components/PersonalDetails/StyledComponents";
import { Button } from "@mui/material";
import { Box } from "@mui/system";

interface OtpVerificationProcessProps {
  identityNumber: string;
  expiryDate: number | null;
  setExpiryDate: React.Dispatch<React.SetStateAction<number | null>>;
  formikSendCode: FormikProps<SendVerificationCode>;
}

export const OtpVerificationProcess: React.FC<OtpVerificationProcessProps> = ({
  identityNumber,
  expiryDate,
  setExpiryDate,
  formikSendCode
}) => {
  if (!expiryDate) return null;

  return (
    <VerificationGrid item xs={12}>
      <StyledTextField
        fullWidth
        id="otp"
        name="otp"
        label="Enter OTP Code"
        value={formikSendCode.values.otp}
        onChange={formikSendCode.handleChange}
        onBlur={formikSendCode.handleBlur}
        type="text"
        inputProps={{ maxLength: 6 }}
        error={formikSendCode.touched.otp && Boolean(formikSendCode.errors.otp)}
        helperText={
          formikSendCode.touched.otp &&
          (formikSendCode.errors.otp as React.ReactNode)
        }
      />

      <CountDownTimer
        initialSeconds={expiryDate}
        username={identityNumber}
        setExpiryDate={setExpiryDate}
      />

      
    </VerificationGrid>
  );
};

export default OtpVerificationProcess;
